import React from "react";
import {updateStore} from "./update.store";
import {linksStore} from "./links.store"

const storesContext = React.createContext({
    updateStore,
    linksStore,
});

export const useStores = () => React.useContext(storesContext);